import React from 'react';
import { IconProps } from './types';

const StepBackwards: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={1.15625 * size}
    height={size}
    viewBox="0 0 37 32"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M35.5 1.4v0c1.65 1.65 1.65 4.5 0 6.15l-8.6 8.45 8.6 8.6c1.65 1.65 1.65 4.5 0 6.15v0c-1.65 1.65-4.5 1.65-6.15 0l-11.55-11.55c-0.9-0.9-1.3-1.9-1.3-3.1s0.4-2.2 1.3-3.1l11.55-11.45c1.8-1.95 4.5-1.95 6.15-0.15z"
    />
    <path
      fill={!ignoreColor ? color : undefined}
      d="M4.35 31.9v0c-2.45 0-4.35-1.9-4.35-4.35v-23.2c0-2.45 1.9-4.35 4.35-4.35v0c2.45 0 4.35 1.9 4.35 4.35v23.2c0 2.45-1.9 4.35-4.35 4.35z"
    />
  </svg>
);

export default StepBackwards;
